import BooleanEqualsComparatorEvaluator from "./BooleanEqualsComparatorEvaluator.js";
export default class BooleanFalseComparatorEvaluator extends BooleanEqualsComparatorEvaluator {
  value = false;
}